<template>
    <div>
        <div class="row">
            <div class="col-12 col-md-4 col-sm-6 pb-3">
                <div class="d-flex flex-column">
                    <label class="fw-semibold">{{ $tm('import.name') }}</label>
                    <span class="ms-2">{{ details.Name }}</span>
                </div>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3">
                <div class="d-flex flex-column">
                    <label class="fw-semibold">{{ $tm('import.birthdayage') }}</label>
                    <span class="ms-2">{{ details.Birthday }} / {{ details.Age }}</span>
                </div>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3">
                <div class="d-flex flex-column">
                    <label class="fw-semibold">{{ $tm('import.gender') }}</label>
                    <span class="ms-2">{{ details.Gender }}</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div
                class="col-12 col-md-4 col-sm-6"
                v-if="details.NationalityID"
            >
                <div class="d-flex flex-column">
                    <label class="fw-semibold">{{ $tm('import.country') }}</label>
                    <span class="ms-2">
                        <DisplayCountry :value="details.NationalityID" />
                    </span>
                </div>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3">
                <div class="d-flex flex-column">
                    <label class="fw-semibold">{{ $tm('race.race') }}</label>
                    <span class="ms-2"
                        >{{ details.Race }}
                        <IconComp
                            v-if="details.RaceGenerated"
                            icon="fa-circle-plus"
                            class="text-warning"
                        />
                    </span>
                </div>
            </div>
            <div class="col-12 col-md-4 col-sm-6">
                <div class="d-flex flex-column">
                    <label class="fw-semibold">{{ $tm('import.category') }}</label>
                    <span class="ms-2"
                        >{{ details.Category }}
                        <IconComp
                            v-if="details.CategoryGenerated"
                            icon="fa-circle-plus"
                            class="text-warning"
                        />
                    </span>
                </div>
            </div>
            <div
                class="col-12 col-md-4 col-sm-6"
                v-if="details.Group"
            >
                <div class="d-flex flex-column">
                    <label class="fw-semibold">{{ $tm('import.group') }}</label>
                    <span class="ms-2"
                        >{{ details.Group }}
                        <IconComp
                            v-if="details.GroupGenerated"
                            icon="fa-circle-plus"
                            class="text-warning"
                        ></IconComp>
                    </span>
                </div>
            </div>
            <div
                class="col-12 col-md-4 col-sm-6"
                v-if="details.Team"
            >
                <div class="d-flex flex-column">
                    <label class="fw-semibold">{{ $tm('import.team') }}</label>
                    <span class="ms-2"
                        >{{ details.Team }}
                        <IconComp
                            v-if="details.TeamGenerated"
                            icon="fa-circle-plus"
                            class="text-warning"
                        />
                    </span>
                </div>
            </div>
        </div>

        <div class="text-small py-2 border border-3 border-info border-end-0 border-top-0 border-bottom-0 ps-3 my-3">
            <IconComp
                icon="fa-circle-plus"
                class="text-warning"
            />
            {{ $tm('import.willbegenerated') }}
        </div>

        <AlertMessage
            v-if="details.ErrorMessages.length > 0"
            type="danger"
            :show-icon="false"
        >
            <template #default>
                <div class="d-flex flex-column gap-2">
                    <div
                        v-for="(m, i) in details.ErrorMessages"
                        :key="i"
                        v-html="$ti(m.text, m.values, true)"
                    ></div>
                </div>
            </template>
        </AlertMessage>

        <AlertMessage
            v-if="details.WarningMessages.length > 0"
            type="warning"
            :show-icon="false"
        >
            <template #default>
                <div class="d-flex flex-column gap-2">
                    <div
                        v-for="(m, i) in details.WarningMessages"
                        :key="i"
                        v-html="$ti(m.text, m.values, true)"
                    ></div>
                </div>
            </template>
        </AlertMessage>

        <AlertMessage
            v-if="details.InfoMessages.length > 0"
            type="info"
            :show-icon="false"
        >
            <template #default>
                <div class="d-flex flex-column gap-2">
                    <div
                        v-for="(m, i) in details.InfoMessages"
                        :key="i"
                        v-html="$ti(m.text, m.values, true)"
                    ></div>
                </div>
            </template>
        </AlertMessage>
    </div>
</template>
<script setup lang="ts">
import { IconComp, AlertMessage } from '@/components';
import type { ContestantImportDetails } from './../Import/ContestantImportDetails';
import { $ti } from '@/locize';
import DisplayCountry from '../Basic/DisplayCountry.vue';

const props = defineProps<{
    details: ContestantImportDetails;
}>();
</script>
